import { Chip, Typography } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

const StyledStatusChip = styled(Chip)`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 1;
  background-color: ${(p) => p.theme.colors.background};
`;

interface Props {
  listingStatus: string;
}

export const StatusChip = (props: Props) => {
  const { listingStatus, ...rest } = props;
  return (
    <StyledStatusChip
      {...rest}
      label={
        <Typography variant="overline" fontWeight={700}>
          {listingStatus}
        </Typography>
      }
      size="small"
      variant="text"
      color={listingStatus === "Active" ? "success" : "secondary"}
    />
  );
};
